angular.module("exploitation").factory("InfoService", ["$http", "ENV", function ($http, ENV) {

	/**
	 * API
	 */
	return {
		getFeedInfo: getFeedInfo,
		editFeedInfo: editFeedInfo
	};


	/**
	 * Récupérer le feed_info correspondant au référentiel
	 * @returns {*}
	 */
	function getFeedInfo() {
		return $http.get(ENV.API_URL + "/feed-info");
	}

	/**
	 * Modifier le feed_info correspondant au référentiel
	 * @returns {*}
	 */
	function editFeedInfo(feedInfo) {
		return $http.put(ENV.API_URL + "/feed-info", feedInfo);
	}

}]);
